module.exports = __webpack_public_path__ + "img/SA_provinces.8134fc83.svg";